/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Dpi1Inputs */

const en_coinvestments_report_dpi1 = /** @type {(inputs: Coinvestments_Report_Dpi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DPI`)
};

/**
* | output |
* | --- |
* | "DPI" |
*
* @param {Coinvestments_Report_Dpi1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_dpi1 = /** @type {((inputs?: Coinvestments_Report_Dpi1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Dpi1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_dpi1(inputs)
});
export { coinvestments_report_dpi1 as "coInvestments_report_dpi" }